<template>
  <div class="horizontal-scroll-container py-2" ref="scrollContainer">
    <div class="horizontal-scroll-inner">
      <div class="horizontal-scroll-options" v-for="(option, index) in vehicleBuildOptions" :key="index">
        <router-link
          data-test="router-link"
          ref="horizontal-scroll-element"
          :aria-disabled="option.isDisabled"
          :class="{ isActive: activeOption === index, isDisabled: option.isDisabled }"
          @click.native="nextOption(option.route)"
          :to="option.route"
          >{{ option.name }}</router-link
        >
        <img alt="" v-if="index !== lastArrayElementIndex" :src="backButton" class="flip-horizontally" />
      </div>
    </div>
  </div>
</template>

<script>
import backButton from '@/assets/back-button.svg';

export default {
  name: 'VehicleBuildNavBar',
  components: {},
  props: {
    vehicleBuildOptions: {
      type: Array,
      default: () => [
        {
          name: 'Model',
          route: 'model-select',
        },
        {
          name: 'Trim',
          route: 'trim-select',
        },
        {
          name: 'Colour',
          route: 'colour-select',
        },
        {
          name: 'Vehicle Summary',
          route: 'vehicle-summary',
        },
      ],
    },
  },
  data() {
    return {
      backButton,
    };
  },
  computed: {
    lastArrayElementIndex() {
      return this.vehicleBuildOptions.length - 1;
    },
    activeOption() {
      let currentRouteIndex = 0;
      this.vehicleBuildOptions.forEach((element, index) => {
        if (this.$route.path.includes(element.route)) {
          currentRouteIndex = index;
        }
      });
      return currentRouteIndex;
    },
  },
  watch: {
    activeOption(newVal) {
      this.scrollOptionIntoView(newVal);
    },
  },
  methods: {
    scrollOptionIntoView(index) {
      const { scrollContainer } = this.$refs;
      const horizontalScrollElement = this.$refs['horizontal-scroll-element'];

      if (scrollContainer && horizontalScrollElement) {
        const el = horizontalScrollElement[index].$el;
        const allNavs = scrollContainer.getElementsByClassName('horizontal-scroll-options');

        const targetNavElementWidth = el.offsetWidth;
        const targetPaddingOffset = index === 0 || index === allNavs.length - 1 ? 36 : 32; // First and last nav element have more padding
        const navContainerWidth = scrollContainer.offsetWidth;

        let widthSumOfPrecedingNavElements = 0;
        for (let i = 0; i < index; i += 1) {
          // Sum the width of all nav elements preceding the target nav
          widthSumOfPrecedingNavElements += allNavs[i].offsetWidth;
        }

        widthSumOfPrecedingNavElements += (targetNavElementWidth + targetPaddingOffset) / 2; // Add half the width of the target nav

        /*
        If the sum is more than half the container width, subract half the container width.
        This will make it so that the nav element is centered in the scroll container.
        Otherwise, set it to zero.
        */
        if (widthSumOfPrecedingNavElements > navContainerWidth / 2) {
          widthSumOfPrecedingNavElements -= navContainerWidth / 2;
        } else {
          widthSumOfPrecedingNavElements = 0;
        }

        scrollContainer.scroll({
          left: widthSumOfPrecedingNavElements,
          behavior: 'smooth',
        });
      }
    },
    nextOption(route) {
      this.$router.push({ path: route });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.horizontal-scroll-container {
  overflow-x: auto;
  background-color: #f0f4f7;
  white-space: nowrap;

  .horizontal-scroll-inner {
    text-align: center;
  }

  .horizontal-scroll-options {
    display: inline-block;

    &:first-child {
      padding-left: 4px;
    }

    &:last-child {
      padding-right: 4px;
    }

    a {
      color: #4b5863;
      font-size: 14px;
      font-weight: 700;
      line-height: 17.5px;
      padding-right: 37px;
      padding-left: 37px;

      @media (max-width: $breakpoint-mobile) {
        padding-right: 17px;
        padding-left: 17px;
      }

      &.isActive {
        color: $primary-dark;
      }

      &.isDisabled {
        pointer-events: none;
        opacity: 0.7;
      }
    }
  }
}

.flip-horizontally {
  transform: scaleX(-1);
  height: 14px;
}

/* hide scrollbar but allow scrolling */
.horizontal-scroll-container {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
}

.horizontal-scroll-container::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
</style>
